// extracted by mini-css-extract-plugin
export default {"imageWrapper":"LF-z","twoColumnImage":"MF-z"};